import React from "react";

const SecurityBanner = () => {
  return (
    <div className="xl:max-w-7xl mx-auto px-4">
      <div
        className=" relative bg-gradient-to-r from-indigo-400 to-purple-500 rounded-lg p-6 md:p-10 text-white overflow-hidden"
        style={{
          backgroundImage:
            "url('/assests/images/LandingPage/security/Banner1.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-400 to-purple-500 opacity-90 rounded-lg"></div>
        <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between">
          {/* Left Section */}
          <div className="mb-6 md:mb-0">
            <div className="flex items-center space-x-3">
              <img
                src="/assests/images/LandingPage/security/Icon1.webp"
                alt="FingerPrint"
                className="w-16 h-16 md:w-18"
              />
              <span className="text-xl md:text-4xl font-bold">
                Securing Your Data <br />
                Is Our <span className="text-white">Priority</span>
              </span>
            </div>
          </div>

          {/* Right Section */}
          <div className="grid grid-cols-2 gap-4 md:gap-6">
            <div className="flex items-center space-x-2">
              <span className="text-green-400 font-bold text-xl">✔</span>
              <span className="text-sm md:text-base">
                State of the art security measures
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-green-400 font-bold text-xl">✔</span>
              <span className="text-sm md:text-base">
                Robust access control
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-green-400 font-bold text-xl">✔</span>
              <span className="text-sm md:text-base">
                Regular Security Audits
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-green-400 font-bold text-xl">✔</span>
              <span className="text-sm md:text-base">
                Data integrity & backup
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityBanner;
